module.exports = __webpack_public_path__ + "static/media/dropdownEdetailIcon.dcfd0cbc.svg";